/* eslint-disable @typescript-eslint/explicit-function-return-type */
import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export type PostModelPredictionRequestBody = {
  inputs: {
    data: CF.API.ModelOutputs.PostModelPredictBody;
  }[];
  runner_selector?: CF.API.ModelOutputs.RunnerSelector;
  model?: DeepPartial<CF.API.Models.Model>;
};

type PostModelPredictionTEProps = {
  modelId: string;
  body: PostModelPredictionRequestBody;
  userId: string;
  appId: string;
  modelVersionId?: null | string;
  sessionToken?: string;
  signal?: AbortSignal;
};

export const postModelPredictionTE = <E = CF.API.ModelOutputs.ModelOutputsResponse>(
  { modelId, body, userId, appId, modelVersionId, sessionToken, signal }: PostModelPredictionTEProps,
  onRejected?: (e: Error | CF.API.ModelOutputs.ModelOutputsResponse) => E,
): TaskEither<E, CF.API.ModelOutputs.ModelOutputsResponse> =>
  fetchTE<CF.API.ModelOutputs.ModelOutputsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/apps/${appId}/models/${modelId}${modelVersionId ? `/versions/${modelVersionId}` : ''}/outputs`,
      method: 'POST',
      body,
      sessionToken,
      signal,
    },
    onRejected,
  );
